/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// Status Codes that can be thrown by WAM
export const USER_INTERACTION_REQUIRED = "USER_INTERACTION_REQUIRED";
export const USER_CANCEL = "USER_CANCEL";
export const NO_NETWORK = "NO_NETWORK";
export const TRANSIENT_ERROR = "TRANSIENT_ERROR";
export const PERSISTENT_ERROR = "PERSISTENT_ERROR";
export const DISABLED = "DISABLED";
export const ACCOUNT_UNAVAILABLE = "ACCOUNT_UNAVAILABLE";
export const UX_NOT_ALLOWED = "UX_NOT_ALLOWED";
